import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import apiClient from "../services/api";

const ERROR_MESSAGES: Record<string, string> = {
  "Invalid or expired token": "Link wygasł lub jest nieprawidłowy",
  "No token provided": "Brak tokenu w linku",
  "Verification failed": "Weryfikacja nie powiodła się",
  "Network error during verification": "Błąd połączenia podczas weryfikacji",
};

const translateError = (error: string): string => {
  return ERROR_MESSAGES[error] || error;
};

const MagicLinkVerify: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [status, setStatus] = useState<"verifying" | "success" | "error">(
    "verifying"
  );
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    const verifyToken = async () => {
      const params = new URLSearchParams(location.search);
      const token = params.get("token");

      if (!token) {
        setStatus("error");
        setErrorMessage("No token provided");
        setTimeout(() => navigate("/login"), 5000);
        return;
      }

      try {
        const { data } = await apiClient.post("/auth/verify-token", { token });

        if (data.success) {
          localStorage.setItem("token", data.access_token);
          setStatus("success");
          setTimeout(() => navigate("/"), 1500);
        } else {
          setStatus("error");
          setErrorMessage(data.error || "Verification failed");
          setTimeout(() => navigate("/login"), 5000);
        }
      } catch (error) {
        setStatus("error");
        setErrorMessage("Network error during verification");
        setTimeout(() => navigate("/login"), 5000);
      }
    };

    verifyToken();
  }, [location, navigate]);

  return (
    <div className="min-h-screen bg-neutral-50 flex items-center justify-center">
      <div className="text-center">
        {status === "verifying" && (
          <>
            <h2 className="text-2xl font-semibold text-neutral-900">
              Weryfikacja linku logowania...
            </h2>
            <p className="text-neutral-600 mt-2">Proszę czekać.</p>
          </>
        )}

        {status === "success" && (
          <>
            <h2 className="text-2xl font-semibold text-green-600">
              Logowanie udane!
            </h2>
            <p className="text-neutral-600 mt-2">
              Przekierowuję na stronę główną...
            </p>
          </>
        )}

        {status === "error" && (
          <>
            <h2 className="text-2xl font-semibold text-red-600">
              Logowanie nie powiodło się
            </h2>
            <p className="text-neutral-600 mt-2">
              {translateError(errorMessage)}
            </p>
            <p className="text-sm text-neutral-500 mt-4">
              Zaloguj się ponownie:{" "}
              <Link
                to="/login"
                className="text-primary-700 hover:text-primary-800 underline"
              >
                Przejdź do strony logowania
              </Link>
            </p>
            <p className="text-xs text-neutral-400 mt-2">
              Za chwilę nastąpi automatyczne przekierowanie...
            </p>
          </>
        )}
      </div>
    </div>
  );
};

export default MagicLinkVerify;
